import React from 'react';

import { useAppSelector } from 'flow/hooks/useRedux';
import { selectExtension } from 'flow/selectors/ExtensionSelectors';

import Button from 'flow/components/ui-components/Button';
import ContactAvatar from 'flow/components/ui-components/ContactAvatar';

import { extractName } from 'flow/utils';

import { ContactFull } from 'flow/types/Contact';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { TypedMap } from 'flow/types/TypedMap';

interface Props {
    extensionKey: ExtensionKey;
    onRemove: (key: ExtensionKey) => void;
}

const ParticipantPill = ({ extensionKey, onRemove }: Props) => {
    const extension = useAppSelector((state) =>
        selectExtension(state, extensionKey),
    );
    if (!extension) return null;
    const contact = extension.get('contact') as TypedMap<ContactFull>;

    const handleRemove = (e: React.MouseEvent) => {
        e.stopPropagation();
        onRemove(extensionKey);
    };

    return (
        <div className="flex items-center gap-x-1 rounded-sm border border-gray-300 bg-white ps-1">
            <ContactAvatar size="small" contact={contact} lazyLoad={true} />
            <p className="text-sm">{extractName(contact)}</p>
            <Button
                className="text-gray-400"
                iconKey="cancel"
                onClick={handleRemove}
            />
        </div>
    );
};

export default ParticipantPill;
